module.exports = __webpack_public_path__ + "img/face-demo-new.bb3e7c2a.png";